$(function() {
	$('.open-menu').click(function() {
		if (($(window).width() > 999) && ($(this).hasClass('collapsed'))) {
			$(this).removeClass('collapsed');
			$('#navbarBrand').addClass('active');
			$("#lateralMenu").addClass("active");

			$("#lateralMenu li").each(function(i){
				var delay = i*30;

				$(this)
				.velocity({
					opacity: "0",
					translateX: "-10px",
				}, 0)
				.velocity({
					opacity: 1,
					translateX: "0",
				},{duration: 600, delay: delay, queue:false}, [0,0.711,0,1])
			});

			var timeout = setTimeout(function(){
				$('.language-toggle').addClass('active');
				clearTimeout(timeout);
			}, 500);

		} else if (($(window).width() > 999) && (!$(this).hasClass('collapsed'))) {
			$(this).addClass('collapsed');
			$('.language-toggle').removeClass('active');
			$("#searchResults").removeClass('active')

			$("#lateralMenu li").each(function(i){
				var delay = i*30;

				$(this)
				.velocity({
					opacity: "0",
					translateX: "-10px",
				}, {duration: 200, delay: delay, queue:false}, [0.490, 0.150, 0.090, 0.995])
				.velocity({
					opacity: 1,
					translateX: "0",
				}, 0);
			});

			var timeout = setTimeout(function(){
				$('#navbarBrand').removeClass('active');
				$("#lateralMenu").removeClass("active");
				clearTimeout(timeout);
			}, 500);


		} else {
			$('body').addClass('modal-open');
			$(this).removeClass('collapsed');
			$("#lateralMenu").addClass("active")

			$(".navbar-close")
			.velocity({
				rotateX: "-90deg",
				opacity: "0"
			},0);

			$("#lateralMenu li").each(function(i){
				var delay = i*50;
				$(this)
				.velocity({
					opacity: "0.2",
					translateY: "-30px",
				}, 0)
				.velocity({
					opacity: 1,
					translateX: "0",
					translateY: "0",
				},{duration: 700, delay: delay, queue:false}, [0.490, 0.150, 0.090, 0.995])
			});

			$(".navbar-close")
			.velocity({
				rotateX: "0",
				opacity: "1"
			},{duration: 400, delay: 600}, [0.490, 0.150, 0.090, 0.995]);
		};
	});

	function closeMenu() {
		$('body').removeClass('modal-open');
		$('.open-menu').addClass('collapsed');
		$("#lateralMenu").removeClass("active");
		$('#navbarBrand').removeClass("active");
		$('.language-toggle').removeClass("active");
	};

	// $(window).resize(function(){
		if ($(window).width() < 1002) {
			closeMenu();
		};
	// });

	$('.navbar-close').click(function() {
		closeMenu();
	});
});
